import { useHistory } from "react-router-dom";

const Migas = () => {
  const history = useHistory();
  const clickInicio = () => {
    history.push({
      pathname: "/",
    });
  };

  const clickLista = () => {
    history.push({
      pathname: history.location.pathname.split("/", 3).join("/"),
    });
  };
  return [clickInicio, clickLista];
};
export default Migas;
